<template>
  <div class="grid gap-32">
    <template v-for="(section, sIndex) in content.sections" :key="sIndex">
      <ImageStrip v-if="section.type === 'images'" :images="section.images" />

      <ArticleQuote
        v-else-if="section.type === 'quote'"
        :text="section.text"
        :attribution="section.attribution"
      />

      <div v-else-if="section.type === 'prose'">
        <template v-for="(block, bIndex) in section.blocks" :key="bIndex">
          <h3 v-if="block.title" class="raw-heading-3 mb-8 !text-[18px]">
            {{ i18n(block.title) }}
          </h3>
          <p class="[&:not(:last-child)]:mb-16">
            <InlineMarkdown :message="block.text" />
          </p>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import ImageStrip from '~/scopes/campaign/components/UI/ImageStrip.vue'
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import ArticleQuote from '~/scopes/campaign/components/impacts/article/ArticleQuote.vue'
import type { ArticleContent } from '~/scopes/campaign/data/articles/data'

// Walks the ordered sections so prose, image strips and pull quotes interleave
// exactly as authored. The first block of a themed run carries its subhead.
//
// Every branch tests its own `type` — none of them is the `v-else`. A bare `v-else`
// would silently mean "prose", so the next section type added to the union would
// land there and blow up on a missing `blocks`.
defineProps<{ content: ArticleContent }>()

const i18n = useI18n()
</script>
